import React, { useState, useEffect } from "react";

const CartPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const [formData, setFormData] = useState({
    jmeno: "",
    prijmeni: "",
    email: "",
    telefon: "",
    adresa: "",
    firma: "",
    ico: "",
    dic: "",
  });

  // 🔹 Načtení košíku z localStorage
  useEffect(() => {
    const storedCart = localStorage.getItem("visionhome_cart");
    if (storedCart) {
      setCartItems(JSON.parse(storedCart));
    }
  }, []);

  // 🔹 Výpočet celkové ceny
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.unit_price_with_vat * item.quantity,
    0
  );

  // 🔹 Změna hodnot formuláře
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // 🔹 Odeslání poptávky e-mailem přes EmailJS
  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailBody = `
      🧾 NOVÁ POPTÁVKA Z VISIONHOME 💚

      👤 Zákazník:
      Jméno: ${formData.jmeno} ${formData.prijmeni}
      E-mail: ${formData.email}
      Telefon: ${formData.telefon}

      🏠 Fakturační údaje:
      Firma: ${formData.firma}
      Adresa: ${formData.adresa}
      IČO: ${formData.ico}
      DIČ: ${formData.dic}

      ------------------------
      🛒 Objednané položky:
      ${cartItems
        .map(
          (item) =>
            `• ${item.name} (${item.package}) – ${item.quantity} ks × ${item.unit_price_with_vat.toFixed(
              2
            )} Kč`
        )
        .join("\n")}
      ------------------------
      Celkem: ${totalPrice.toFixed(2)} Kč s DPH
    `;

    // 🔸 EmailJS volání
    try {
      await fetch("https://formsubmit.co/ajax/thefixwinner@gmail.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          _subject: "Nová poptávka z VisionHome",
          message: emailBody,
        }),
      });
      alert("✅ Poptávka byla úspěšně odeslána!");
      localStorage.removeItem("visionhome_cart");
      setCartItems([]);
      setFormData({
        jmeno: "",
        prijmeni: "",
        email: "",
        telefon: "",
        adresa: "",
        firma: "",
        ico: "",
        dic: "",
      });
    } catch (error) {
      alert("❌ Chyba při odesílání. Zkuste to znovu.");
    }
  };

  return (
    <div className="min-h-screen bg-neutral-950 text-white p-8">
      <a
        href="/shop"
        className="text-lime-400 font-semibold text-lg underline hover:text-lime-300"
      >
        ← Zpět do katalogu
      </a>

      <h1 className="text-3xl font-bold text-lime-400 text-center mb-6">
        Rekapitulace poptávky
      </h1>

      {cartItems.length === 0 ? (
        <p className="text-center text-gray-400">Košík je prázdný.</p>
      ) : (
        <>
          {/* 🛒 Výpis produktů */}
          <div className="bg-neutral-900 p-6 rounded-2xl mb-8 border border-neutral-800">
            {cartItems.map((item, index) => (
              <div
                key={index}
                className="flex justify-between border-b border-neutral-800 py-2"
              >
                <div>
                  <p className="font-semibold">{item.name}</p>
                  <p className="text-sm text-gray-400">{item.package}</p>
                </div>
                <div className="text-right">
                  <p>
                    {item.quantity}× {item.unit_price_with_vat.toFixed(2)} Kč
                  </p>
                  <p className="text-lime-400 font-bold">
                    {(item.quantity * item.unit_price_with_vat).toFixed(2)} Kč
                  </p>
                </div>
              </div>
            ))}
            <div className="text-right mt-4 font-bold text-lime-400 text-xl">
              Celkem: {totalPrice.toFixed(2)} Kč s DPH
            </div>
          </div>

          {/* 🧾 Fakturační údaje */}
          <form
            onSubmit={handleSubmit}
            className="bg-neutral-900 p-6 rounded-2xl border border-neutral-800 max-w-2xl mx-auto"
          >
            <h2 className="text-2xl font-semibold text-lime-400 mb-4 text-center">
              Fakturační údaje
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="jmeno"
                placeholder="Jméno"
                value={formData.jmeno}
                onChange={handleChange}
                required
                className="p-2 rounded bg-neutral-800 text-white border border-neutral-700"
              />
              <input
                type="text"
                name="prijmeni"
                placeholder="Příjmení"
                value={formData.prijmeni}
                onChange={handleChange}
                required
                className="p-2 rounded bg-neutral-800 text-white border border-neutral-700"
              />
              <input
                type="email"
                name="email"
                placeholder="E-mail"
                value={formData.email}
                onChange={handleChange}
                required
                className="p-2 rounded bg-neutral-800 text-white border border-neutral-700"
              />
              <input
                type="tel"
                name="telefon"
                placeholder="Telefon"
                value={formData.telefon}
                onChange={handleChange}
                required
                className="p-2 rounded bg-neutral-800 text-white border border-neutral-700"
              />
              <input
                type="text"
                name="firma"
                placeholder="Název firmy"
                value={formData.firma}
                onChange={handleChange}
                className="p-2 rounded bg-neutral-800 text-white border border-neutral-700"
              />
              <input
                type="text"
                name="adresa"
                placeholder="Adresa (ulice, město, PSČ)"
                value={formData.adresa}
                onChange={handleChange}
                required
                className="p-2 rounded bg-neutral-800 text-white border border-neutral-700"
              />
              <input
                type="text"
                name="ico"
                placeholder="IČO"
                value={formData.ico}
                onChange={handleChange}
                className="p-2 rounded bg-neutral-800 text-white border border-neutral-700"
              />
              <input
                type="text"
                name="dic"
                placeholder="DIČ"
                value={formData.dic}
                onChange={handleChange}
                className="p-2 rounded bg-neutral-800 text-white border border-neutral-700"
              />
            </div>

            <button
              type="submit"
              className="mt-6 w-full bg-lime-400 text-black font-semibold py-3 rounded-lg hover:bg-lime-300"
            >
              Odeslat poptávku
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default CartPage;
